module.exports = __webpack_public_path__ + "static/10-614a3948e28b72aae029f8972f8a5a4b.png";